export default __webpack_public_path__ + "static/media/CLOCK_ICON.698dd0b9.svg";